import { Catalog } from './catalog';
import { Company } from './company';
import { Country } from './country';
import { Course } from './course';
import { Salutation } from './salutation';

export class User {
    public id?: number;
    public username?: string;
    public email?: string;
    public password?: string;
    public token?: string;
    public firstName?: string;
    public lastName?: string;
    public company?: Company;
    public title?: string;
    public department?: string;
    public address?: string;
    public houseNumber?: string;
    public phone?: string;
    public phoneNumber?: string;
    public city?: string;
    public zipCode?: string;
    public country?: Country;
    public catalogs?: Catalog[];
    public upcomingCourses?: Course[];
    public subscribe?: boolean;
    public salutation?: Salutation;

    public departmentNumber?: string;
    public badgeNumber?: string;
    public regionKey?: string;
    public enrolmentContactId?: string;
    public billingContactId?: string;
    public sameAsPerson?: boolean;
    public note?: string;
    public POnumber?: number;

    constructor(data) {
        this.id = data.id || null;
        this.username = data.username || null;
        this.email = data.email || null;
        this.password = data.password || null;
        this.token = data.token || null;
        this.firstName = data.firstName || null;
        this.lastName = data.lastName || null;
        this.company = data.company || null;
        this.title = data.title || null;
        this.department = data.department || null;
        this.departmentNumber = data.departmentNumber || null;
        this.address = data.address || null;
        this.houseNumber = data.houseNumber || null;
        this.phone = data.phone || null;
        this.phoneNumber = data.phoneNumber || null;
        this.city = data.city || null;
        this.zipCode = data.zipCode || null;
        this.country = data.country || null;
        this.catalogs = data.catalogs || null;
        this.upcomingCourses = data.upcomingCourses || null;
        this.subscribe = data.subscribe || null;
        this.salutation = data.salutation || null;

        this.departmentNumber = data.departmentNumber || null;
        this.badgeNumber = data.badgeNumber || null;
        this.regionKey = data.regionKey || null;
        this.enrolmentContactId = data.enrolmentContactId || null;
        this.billingContactId = data.billingContactId || null;

        this.note = data.note || null;
        this.POnumber = data.POnumber || null;
    }
}
